module.exports = __webpack_public_path__ + "static/Devices@2x-6f636738e0d18da6bd2e68d824a5c111.png";